import {BusinessUnit} from '../message/BusinessUnit';
import {BusinessUnitDuplicationScenario} from './BusinessUnitDuplicationScenario';
import {DuplicationWrapper} from '../../framework/parameters/DuplicationWrapper';

export class BusinessUnitDuplicationWrapper extends DuplicationWrapper<BusinessUnit, BusinessUnitDuplicationScenario>  {}

